import axios from "axios";
import { Base_URL } from "../url";

export const fetchGrades = async () => {
  try {
    const response = await axios.get(`${Base_URL}/GradeMaster`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching grades!";
  }
};